/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let SuperSkuImport;
let ConsumerCardMessagingImport;
let OrderSampleImport;
let GlobalCustomConfiguratorImport;
let AisleBayImport;
let QuestionsAndAnswersAccordionBodyImport;
let RatingsAndReviewsAccordionBodyImport;
let SpecificationsAccordionBodyImport;
let ProductOverviewAccordionBodyImport;

/** *********************
 * Aisle Bay
 ********************** */
export const AisleBayLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "aisle-bay" */
  '@thd-olt-component-react/aisle-bay')
  .then((module) => {
    const { AisleBay } = module;

    AisleBayImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'aisle-bay'}
        >
          <AisleBay {...props} />
        </QueryProvider>
      );
    };
  });

export const AisleBay = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay')).AisleBay
  : (props) => <AisleBayImport {...props} />;

export const AisleBayModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay')).AisleBay.dataModel
  : {};

/** *********************
 * Consumer Card Messaging
 ********************** */
export const ConsumerCardMessagingLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "consumer-card-messaging" */
  '@thd-olt-component-react/consumer-card-messaging')
  .then((module) => {
    const { ConsumerCardMessaging } = module;

    ConsumerCardMessagingImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'ccm'}
        >
          <ConsumerCardMessaging {...props} />
        </QueryProvider>
      );
    };
  });

export const ConsumerCardMessaging = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging')).ConsumerCardMessaging
  : (props) => <ConsumerCardMessagingImport {...props} />;

export const ConsumerCardMessagingModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging')).ConsumerCardMessaging.dataModel
  : {};

/** *********************
 * Super Sku
 ********************** */
export const SuperSkuLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "super-sku" */
  '@thd-olt-component-react/super-sku')
  .then((module) => {
    const { SuperSku } = module;

    SuperSkuImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'ssku'}
        >
          <SuperSku {...props} />
        </QueryProvider>
      );
    };
  });

export const SuperSku = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku')).SuperSku
  : (props) => <SuperSkuImport {...props} />;

export const SuperSkuModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku')).SuperSku.dataModel
  : {};

/** *********************
 * Order Sample
 ********************** */
export const OrderSampleLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "order-sample" */
  '@thd-olt-component-react/order-sample')
  .then((module) => {
    const { OrderSample } = module;

    OrderSampleImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'sample'}
        >
          <OrderSample {...props} />
        </QueryProvider>
      );
    };
  });

export const OrderSample = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample')).OrderSample
  : (props) => <OrderSampleImport {...props} />;

export const OrderSampleModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample')).OrderSample.dataModel
  : {};

/** *********************
 * Global Custom Configurator
 ********************** */
export const GlobalCustomConfiguratorLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "global-custom-configurator" */
  '@thd-olt-component-react/global-custom-configurator')
  .then((module) => {
    const { GlobalCustomConfigurator } = module;

    GlobalCustomConfiguratorImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'global-custom-config'}
        >
          <GlobalCustomConfigurator {...props} />
        </QueryProvider>
      );
    };
  });

export const GlobalCustomConfigurator = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator')).GlobalCustomConfigurator
  : (props) => <GlobalCustomConfiguratorImport {...props} />;

export const GlobalCustomConfiguratorModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator')).GlobalCustomConfigurator.dataModel
  : {};

/** *********************
 * Questions and Answers
 ********************** */
export const QuestionsAndAnswersAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "questions-and-answers" */
  '@thd-olt-component-react/questions-and-answers')
  .then((module) => {
    const { QuestionsAndAnswersAccordionBody } = module;

    QuestionsAndAnswersAccordionBodyImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'q-and-a'}
        >
          <QuestionsAndAnswersAccordionBody {...props} />
        </QueryProvider>
      );
    };
  });

export const QuestionsAndAnswersAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers')).QuestionsAndAnswersAccordionBody
  : (props) => <QuestionsAndAnswersAccordionBodyImport {...props} />;

export const QuestionsAndAnswersAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers')).QuestionsAndAnswersAccordionBody.dataModel
  : {};

/** *********************
 * Ratings and Reviews
 ********************** */
export const RatingsAndReviewsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews" */
  '@thd-olt-component-react/ratings-and-reviews')
  .then((module) => {
    const { RatingsAndReviewsAccordionBody } = module;

    RatingsAndReviewsAccordionBodyImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'r-and-r'}
        >
          <RatingsAndReviewsAccordionBody {...props} />
        </QueryProvider>
      );
    };
  });

export const RatingsAndReviewsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews')).RatingsAndReviewsAccordionBody
  : (props) => <RatingsAndReviewsAccordionBodyImport {...props} />;

export const RatingsAndReviewsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews')).RatingsAndReviewsAccordionBody.dataModel
  : {};

/** *********************
* Specifications
********************** */
export const SpecificationsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "specifications" */
  '@thd-olt-component-react/specifications')
  .then((module) => {
    const { SpecificationsWithKPFAccordionBody } = module;

    SpecificationsAccordionBodyImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'spec-accordion'}
        >
          <SpecificationsWithKPFAccordionBody {...props} />
        </QueryProvider>
      );
    };
  });

export const SpecificationsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications')).SpecificationsWithKPFAccordionBody
  : (props) => <SpecificationsAccordionBodyImport {...props} />;

export const SpecificationsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications')).SpecificationsWithKPFAccordionBody.dataModel
  : {};

/** *********************
* PaintReorder Overview
********************** */
export const ProductOverviewAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview" */
  '@thd-olt-component-react/product-overview')
  .then((module) => {
    const { ProductOverviewAccordionBody } = module;

    ProductOverviewAccordionBodyImport = (props) => {
      const qctx = props.qctx;
      return (
        <QueryProvider
          defaultVariables={qctx.defaultVariables.current}
          cacheKey={qctx.cacheKey + 'product-overview'}
        >
          <ProductOverviewAccordionBody {...props} />
        </QueryProvider>
      );
    };
  });

export const ProductOverviewAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).ProductOverviewAccordionBody
  : (props) => <ProductOverviewAccordionBodyImport {...props} />;

export const ProductOverviewAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).ProductOverviewAccordionBody.dataModel
  : {};
